export const TEAM_VENUE_DOME = 'D';
export const TEAM_VENUE_OUTDOORS = 'O';
export const TEAM_VENUE_RETRACTABLE = 'R';
